import { ReactNode } from "react"
import { Head, Link, usePage } from "@inertiajs/react"
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card"
import { Button } from "../components/ui/button"
import { Mail, CheckCircle, AlertCircle } from "lucide-react"
import Layout from "../layouts/Layout"

declare module '@inertiajs/core' {
  interface PageProps {
    success?: boolean
    message?: string
    email?: string
  }
}

const Unsubscribe = () => {
  const { success, message, email } = usePage().props

  return (
    <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="max-w-2xl mx-auto">
        <Head title="Newsletter Unsubscribe" />
        
        <Card className="text-center">
          <CardHeader>
            <div className="flex justify-center mb-4">
              <div className="p-3 rounded-full bg-primary/10">
                <Mail className="h-8 w-8 text-primary" />
              </div>
            </div>
            <CardTitle className="text-2xl font-bold">
              Newsletter Unsubscribe
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-6">
            {success ? (
              <>
                <div className="flex justify-center">
                  <CheckCircle className="h-12 w-12 text-green-500" />
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-green-700 mb-2">
                    Successfully Unsubscribed
                  </h3>
                  <p className="text-muted-foreground mb-4">
                    {message || "You have been successfully unsubscribed from our newsletter."}
                  </p>
                  {email && (
                    <p className="text-sm text-muted-foreground">
                      Email: <span className="font-mono">{email}</span>
                    </p>
                  )}
                </div>
              </>
            ) : (
              <>
                <div className="flex justify-center">
                  <AlertCircle className="h-12 w-12 text-red-500" />
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-red-700 mb-2">
                    Invalid Unsubscribe Link
                  </h3>
                  <p className="text-muted-foreground mb-4">
                    {message || "The unsubscribe link you used is invalid or has expired."}
                  </p>
                </div>
              </>
            )}
            
            <div className="pt-4 border-t">
              <p className="text-sm text-muted-foreground mb-4">
                We're sorry to see you go! If you change your mind, you can always resubscribe to our newsletter.
              </p>
              <div className="flex flex-col sm:flex-row gap-3 justify-center">
                <Button asChild>
                  <Link href="/blog">
                    Back to Blog
                  </Link>
                </Button>
                <Button variant="outline" asChild>
                  <Link href="/">
                    Go to Homepage
                  </Link>
                </Button>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}

Unsubscribe.layout = (page: ReactNode) => <Layout>{page}</Layout>

export default Unsubscribe
